import { render, staticRenderFns } from "./BatchImports.vue?vue&type=template&id=634447b7&scoped=true"
import script from "./BatchImports.vue?vue&type=script&lang=js"
export * from "./BatchImports.vue?vue&type=script&lang=js"
import style0 from "./BatchImports.vue?vue&type=style&index=0&id=634447b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634447b7",
  null
  
)

export default component.exports